<template>
  <div class="">
    <v-card flat class="px-3" elevation="3" @click="goToMap(area)">
      <v-row>
        <v-col cols="6" xl="5" lg="6" md="6" sm="6" xs="3">
          <v-img
            v-if="area.cropZoneCenter"
            class="area__img-map"
            height="150px"
            weight="150px"
            :src="`https://image.maps.hereapi.com/mia/v3/base/mc/center:${area.cropZoneCenter.lat},${area.cropZoneCenter.lng};zoom=12/256x256/png?apiKey=0ZQXvkZ0rddyktNimruIMs2TUyFCAIkPisTmyzKGhcY&style=explore.satellite.day&overlay=point:${area.cropZoneCenter.lat},${area.cropZoneCenter.lng};icon=cp;size=large|${area.cropZoneCenter.lat},${area.cropZoneCenter.lng};style=circle;width=25m;color=%231B9D2C60`"
          ></v-img>
          <v-img
            v-else
            class="area__img-map"
            height="150px"
            weight="150px"
            :src="require('@/assets/img/no_image_icon.png')"
          ></v-img>
        </v-col>
        <v-col cols="6" xl="5" lg="6" md="6" sm="6" xs="3" class="pl-0">
          <v-row>
            <v-card-text>
              <v-row>
                <div
                  class="pt-3 ml-2 font-weight-bold d-flex"
                  style="font-size: 1.05em"
                >
                  {{ area.cropZoneName }}
                </div>
              </v-row>
              <v-row>
                <div class="mt-2 ml-2" v-if="area.cropZoneSize">
                  {{ parseFloat(area.cropZoneSize).toFixed(2) }} Ha
                </div>
                <div class="mt-2 ml-2" v-else>0 Ha</div>
              </v-row>
            </v-card-text>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import moment from "moment";
export default {
  data() {
    return {};
  },
  props: {
    area: {
      type: Object,
      required: true,
    },
  },
  mounted() {
console.log(this.area);
  },
  methods: {
    ...mapMutations("areasList", ["SET_AREA_SELECTED"]),
    goToMap(area) {
      this.SET_AREA_SELECTED(area);
      this.$router.back();
      // this.$router.push({
      //   name: "Territorio",
      //   params: {
      //     id: area.id,
      //   },
      // });
    },
    getCropName(area) {
      if (area.cropCycles && area.cropCycles.length > 0) {
        if (area.landUse === "cropLand") {
          let cropCycle = area.cropCycles[area.cropCycles.length - 1];

          if (cropCycle) {
            let template = "";
            if (cropCycle.crop.variety == "") {
              template = `${this.setCropName(cropCycle.crop.cropName)}`;
            } else {
              template = `${this.setCropName(cropCycle.crop.cropName)}(${
                cropCycle.crop.variety
              })`;
            }
            if (cropCycle.plantDate != "" && cropCycle.harvestDate != "") {
              var firstDate = moment(cropCycle.plantDate, [
                "MM-DD-YYYY",
                "YYYY-MM-DD",
              ]);
              var secondDate = moment(cropCycle.harvestDate, [
                "MM-DD-YYYY",
                "YYYY-MM-DD",
              ]);
              if (firstDate.isValid() && secondDate.isValid()) {
                const start = firstDate.valueOf();
                const end = secondDate.valueOf();
                const now = moment().valueOf();

                var diffPartial = end - now;
                var diffTotal = end - start;

                var totalDays = diffTotal / (24 * 60 * 60 * 1000);

                var elapseDays = diffPartial / (24 * 60 * 60 * 1000);

                if (elapseDays < 0) {
                  template += " - En pausa";
                } else {
                  var currentDays = totalDays - elapseDays;
                  template += ` - ${parseInt(currentDays)} días`;
                }
              }
            }

            template = template.toLowerCase();

            let cropName = template.includes("otro")
              ? "Otro"
              : template.includes(undefined)
              ? "---"
              : `Cultivo de ${template}`;
            return cropName;
          } else {
            return "Tierra de cultivo";
          }
        } else {
          return "Estéril";
        }
      } else {
        return "Sin manejo agronómico";
      }
    },

    setCropName(name) {
      return this.crops[name];
    },
  },
  computed: {
    ...mapState("areasList", ["crops"]),
  },
};
</script>

<style scoped>
.area__img-map {
  border-radius: 5px;
}
</style>
